<template>
  <div class="site-menubar">
    <div class="site-menubar-body">
      <div>
        <div>
          <ul class="site-menu" data-plugin="menu">

            <li v-for="menuField in menuFields" class="site-menu-item">
              <router-link
                :to="_getRouteLink(menuField)">
                <span class="site-menu-title">{{ t(menuField.DictionaryKeyCode) }}</span>
              </router-link>
            </li>

          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DependenciesLoader  from '../../model/loader/user-base-entities-loader'
import RouterLinkGenerator from '../../model/wrapper/menu-link-params'

export default {
  data () {
    return {
      menuFields: []
    }
  },

  created () {
    if (!this.menuFields.length) {
      this._initMenuItems()
    }
  },

  methods: {

    _click () {
      // console.log($('.site-menubar'))
    },

    /**
     *
     * @private
     */
    _initMenuItems () {
      let success = (response) => {
            this.menuFields = response.data[0].Fields
          },
          error   = (error) => {
            this.handleApiError(error)
          }

      return DependenciesLoader.getUserLeftMenu(success, error)
    },

    /**
     *
     * @private
     */
    _getRouteLink (menuField) {
      return RouterLinkGenerator.getParams(menuField)
    }

  }

}
</script>
